import {
  CHIP_WIDTH_CONTAINER_RATIO,
  EMOJI_WIDTH,
  LANE_WIDTH,
  MAX_LANES,
  MIN_LANES,
  NAME_CHIP_MAX_WIDTH,
  REACTIONS_ZONE_LEFT_INSET,
  REACTIONS_ZONE_MAX_WIDTH,
} from 'features/room-reactions/constants';

export const computeChipMaxWidth = (containerWidth: number): number => {
  if (containerWidth <= 0) {
    return NAME_CHIP_MAX_WIDTH;
  }
  const responsive = containerWidth * CHIP_WIDTH_CONTAINER_RATIO;
  const maxFitting = Math.min(NAME_CHIP_MAX_WIDTH, containerWidth);
  return Math.max(EMOJI_WIDTH, Math.min(maxFitting, responsive));
};

export const computeZoneLeft = (chipMaxWidth: number): number =>
  Math.max(REACTIONS_ZONE_LEFT_INSET, chipMaxWidth / 2);

export const computeZoneWidth = (containerWidth: number, chipMaxWidth: number): number => {
  if (containerWidth <= 0) {
    return 0;
  }
  const zoneLeft = computeZoneLeft(chipMaxWidth);
  const available = Math.max(0, containerWidth - zoneLeft - chipMaxWidth / 2);
  return Math.min(REACTIONS_ZONE_MAX_WIDTH, available);
};

export const computeLaneCount = (zoneWidth: number): number => {
  if (zoneWidth <= 0) {
    return MIN_LANES;
  }
  const fromWidth = Math.floor(zoneWidth / LANE_WIDTH);
  return Math.min(MAX_LANES, Math.max(MIN_LANES, fromWidth));
};

export const computeLeftForLane = (
  laneIndex: number,
  zoneLeft: number,
  zoneWidth: number,
  laneCount: number,
  random: () => number = Math.random
): number => {
  if (zoneWidth <= 0 || laneCount <= 0) {
    return zoneLeft;
  }
  const laneWidth = zoneWidth / laneCount;
  const laneStart = laneIndex * laneWidth;
  const jitterRange = Math.max(0, laneWidth - EMOJI_WIDTH);
  const localCenter = jitterRange > 0 ? EMOJI_WIDTH / 2 + random() * jitterRange : laneWidth / 2;
  return zoneLeft + laneStart + localCenter;
};
